"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudioSelectionMap = void 0;
var ci_component_injector_service_1 = require("@src/services/ci-component-injector.service");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var StudioSelectionMap = /** @class */ (function () {
    function StudioSelectionMap(instance) {
        var _a;
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.mapConfig = (_a = this.config.get.location) === null || _a === void 0 ? void 0 : _a.map;
        this.events$ = new rxjs_1.BehaviorSubject({});
        this.allStudios = [];
        this.centerRequestId = 0;
        this.studioIdsInView = [];
        Object.assign(this, instance);
    }
    StudioSelectionMap.prototype.init = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
        if ((_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.studioMap) === null || _b === void 0 ? void 0 : _b.domElement) {
            (0, ci_component_injector_service_1._InjectStencilWebComponents)();
            this.mapCash = (0, cash_dom_1.default)('<CI-OPEN-STREETMAP>');
            this.mapDomElement = this.mapCash[0];
            this.mapDomElement.clusterLocations = (_d = (_c = this.mapConfig) === null || _c === void 0 ? void 0 : _c.clusterLocations) !== null && _d !== void 0 ? _d : true;
            this.mapDomElement.clusterRadius = (_f = (_e = this.mapConfig) === null || _e === void 0 ? void 0 : _e.clusterRadius) !== null && _f !== void 0 ? _f : 50;
            this.mapDomElement.disabled = (_h = (_g = this.mapConfig) === null || _g === void 0 ? void 0 : _g.disableInteraction) !== null && _h !== void 0 ? _h : false;
            this.mapDomElement.mapStyle = (_k = (_j = this.mapConfig) === null || _j === void 0 ? void 0 : _j.style) !== null && _k !== void 0 ? _k : 'auto';
            if ((_l = this.mapConfig) === null || _l === void 0 ? void 0 : _l.mapStyleUrl) {
                this.mapDomElement.mapStyleUrl = (_m = this.mapConfig) === null || _m === void 0 ? void 0 : _m.mapStyleUrl;
            }
            this.mapDomElement.clickableLocations = (_p = (_o = this.mapConfig) === null || _o === void 0 ? void 0 : _o.clickableLocations) !== null && _p !== void 0 ? _p : true;
            this.mapDomElement.clusterLocationsColors = {
                borderColor: (_s = (_r = (_q = this.mapConfig) === null || _q === void 0 ? void 0 : _q.clusterLocationsColors) === null || _r === void 0 ? void 0 : _r.borderColor) !== null && _s !== void 0 ? _s : 'white',
                borderRadius: (_v = (_u = (_t = this.mapConfig) === null || _t === void 0 ? void 0 : _t.clusterLocationsColors) === null || _u === void 0 ? void 0 : _u.borderRadius) !== null && _v !== void 0 ? _v : '50%',
                borderSize: (_y = (_x = (_w = this.mapConfig) === null || _w === void 0 ? void 0 : _w.clusterLocationsColors) === null || _x === void 0 ? void 0 : _x.borderSize) !== null && _y !== void 0 ? _y : '2px',
                background: (_1 = (_0 = (_z = this.mapConfig) === null || _z === void 0 ? void 0 : _z.clusterLocationsColors) === null || _0 === void 0 ? void 0 : _0.background) !== null && _1 !== void 0 ? _1 : 'black',
                text: (_4 = (_3 = (_2 = this.mapConfig) === null || _2 === void 0 ? void 0 : _2.clusterLocationsColors) === null || _3 === void 0 ? void 0 : _3.text) !== null && _4 !== void 0 ? _4 : '#fff',
            };
            (_5 = this.mapCash) === null || _5 === void 0 ? void 0 : _5.on('change', function (event) {
                _this.changeEvents(event);
            });
            (_7 = (_6 = this.module.references) === null || _6 === void 0 ? void 0 : _6.studioMap) === null || _7 === void 0 ? void 0 : _7.domElement.append(this.mapCash);
        }
    };
    /** Idempotent */
    StudioSelectionMap.prototype.load = function (allStudios, user) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.allStudios = allStudios;
        if ((_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.studioMap) === null || _b === void 0 ? void 0 : _b.domElement) {
            if (!this.mapCash) {
                this.init();
            }
            var mapConfig_1 = (_c = this.config.get.location) === null || _c === void 0 ? void 0 : _c.map;
            var locations = allStudios.map(function (a) { return (__assign(__assign({ lat: a.address.latitude, lon: a.address.longitude, name: (mapConfig_1 === null || mapConfig_1 === void 0 ? void 0 : mapConfig_1.showName) === false ? undefined : a.studioName }, ((mapConfig_1 === null || mapConfig_1 === void 0 ? void 0 : mapConfig_1.icon) && { icon: typeof mapConfig_1.icon === 'string' ? mapConfig_1 === null || mapConfig_1 === void 0 ? void 0 : mapConfig_1.icon : mapConfig_1 === null || mapConfig_1 === void 0 ? void 0 : mapConfig_1.icon(a) })), { color: mapConfig_1 === null || mapConfig_1 === void 0 ? void 0 : mapConfig_1.color, iconSize: mapConfig_1 === null || mapConfig_1 === void 0 ? void 0 : mapConfig_1.iconSize, id: a.id })); });
            if ((user === null || user === void 0 ? void 0 : user.lat) !== undefined && (user === null || user === void 0 ? void 0 : user.lon) !== undefined && ((_d = this.mapConfig) === null || _d === void 0 ? void 0 : _d.showUserLocation)) {
                locations.push({
                    lat: user.lat,
                    lon: user.lon,
                    name: translation_1.default.t('You'),
                    doNotCluster: true,
                    color: (_g = (_f = (_e = this.mapConfig) === null || _e === void 0 ? void 0 : _e.clusterLocationsColors) === null || _f === void 0 ? void 0 : _f.background) !== null && _g !== void 0 ? _g : 'black',
                });
            }
            if (this.locations && (0, lodash_1.isEqual)(locations, this.locations)) {
                return;
            }
            this.locations = (0, lodash_1.cloneDeep)(locations);
            this.mapDomElement.locations = locations;
            void this.updateCenter();
        }
    };
    StudioSelectionMap.prototype.updateCenter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestId, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestId = ++this.centerRequestId;
                        return [4 /*yield*/, customElements.whenDefined('ci-open-streetmap')];
                    case 1:
                        _a.sent();
                        if (requestId !== this.centerRequestId || !this.mapDomElement)
                            return [2 /*return*/];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.mapDomElement.setCenter('locationCenter')];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error('Failed to center studio map', error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    StudioSelectionMap.prototype.changeEvents = function (event) {
        var _a, _b, _c;
        var mapConfig = (_a = this.config.get.location) === null || _a === void 0 ? void 0 : _a.map;
        var changeData = (_b = event.detail) === null || _b === void 0 ? void 0 : _b.data;
        if ((changeData === null || changeData === void 0 ? void 0 : changeData.action) === 'locationClick' && ((_c = changeData.location) === null || _c === void 0 ? void 0 : _c.id) !== undefined) {
            var studio = this.allStudios.find(function (_a) {
                var _b;
                var id = _a.id;
                return String(id) === String((_b = changeData.location) === null || _b === void 0 ? void 0 : _b.id);
            });
            if (studio) {
                this.events$.next({
                    action: 'clicked',
                    studio: studio,
                    event: event,
                });
            }
        }
        var inViewLocations = changeData === null || changeData === void 0 ? void 0 : changeData.inViewLocations;
        if (!inViewLocations || !(mapConfig === null || mapConfig === void 0 ? void 0 : mapConfig.filterListByViewport))
            return;
        var studioIdsInView = Array.from(new Set(inViewLocations
            .map(function (location) { return location.id; })
            .filter(function (id) { return id !== undefined; })
            .map(function (id) { return String(id); }))).sort();
        if ((0, lodash_1.isEqual)(studioIdsInView, this.studioIdsInView))
            return;
        this.studioIdsInView = studioIdsInView;
        var studioIdSet = new Set(studioIdsInView);
        this.events$.next({
            action: 'viewChange',
            filteredStudios: this.allStudios.filter(function (studio) { return studioIdSet.has(String(studio.id)); }),
        });
    };
    return StudioSelectionMap;
}());
exports.StudioSelectionMap = StudioSelectionMap;
